module.exports = __webpack_public_path__ + "img/syukyaku-top-pa002sp.9f6d6487.png";